// extracted by mini-css-extract-plugin
export var container = "_5a-0";
export var error = "_5a-9";
export var label = "_5a-5";
export var light = "_5a-6";
export var md = "_5a-3";
export var sm = "_5a-2";
export var thin = "_5a-8";
export var thinBold = "_5a-7";
export var vertical = "_5a-4";
export var xs = "_5a-1";